import { useCallback } from "react";
import type {
  PasswordLoginMutation,
  PasswordLoginMutationVariables,
} from "@generated/graphql";
import { trackError, trackSuccess } from "@tracking/index";
import { PASSWORD_LOGIN_MUTATION } from "clientState/operations/mutations";
import { LOGIN_METHODS, useRememberMe } from "clientState/useRememberMe";
import { useMutation } from "@edreamsodigeo/frontend-api-client";
import { useTracking } from "@edreamsodigeo/frontend-core";

import type { UseEdoLogin, UseEdoLoginMutate } from "./contract";

export const useEdoLogin: UseEdoLogin = ({ screen, trackingPrefix }) => {
  const { trackEvent } = useTracking();
  const [, setRememberedUser] = useRememberMe();
  const { loading, mutate } = useMutation<
    PasswordLoginMutation,
    PasswordLoginMutationVariables
  >(PASSWORD_LOGIN_MUTATION);

  const passwordLoginMutate: UseEdoLoginMutate = useCallback(
    (request, { onSuccess, onError }) => {
      mutate(
        { request },
        {
          onSuccess: (args) => {
            const { success, user } = args.data.passwordLogin;
            if (success) {
              setRememberedUser(LOGIN_METHODS.password, user);
              trackSuccess({
                trackEvent,
                isEmail: true,
                screen,
                prefix: trackingPrefix,
              });
            } else {
              trackError({
                trackEvent,
                isEmail: true,
                screen,
                prefix: trackingPrefix,
              });
            }
            onSuccess?.(args);
          },
          onError: (args) => {
            trackError({
              trackEvent,
              isEmail: true,
              screen,
              prefix: trackingPrefix,
            });
            onError?.(args);
          },
        },
      );
    },
    [mutate, screen, setRememberedUser, trackEvent, trackingPrefix],
  );

  return {
    loading,
    mutate: passwordLoginMutate,
  };
};
